import React, { useEffect } from "react";
import ForgotEmailVerificationForm from "./ForgotEmailVerificationForm";

function ForgetEmailVerification() {
  return (
    <>
      <div className="d-lg-none verifyEmailLogo w-100">
        {/* <img src={logo} className="mb-3 h_66x object-fit-contain" alt="" /> */}
      </div>
      <ForgotEmailVerificationForm />
    </>
  );
}

export default ForgetEmailVerification;
